import React from "react";
import { PageComponentProps } from "../../interfaces/common";
import styled from "styled-components";
import { pxToEm } from "../../util/helpers";
import constants from "../_globalStyles/constants";
import Button from "../atoms/Button";

const ConfirmationPopupView = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.87);
  z-index: 5;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: ${pxToEm(32, 16)}rem;
`;

const PopupContent = styled.div`
  width: 100%;
  max-width: ${pxToEm(360, 16)}rem;
  background: ${constants.MAIN_LIGHT_COLOR};
  border: 1px solid ${constants.OK_BRAND_COLOR};
  border-radius: ${pxToEm(24, 16)}rem;
  padding: ${pxToEm(24, 16)}rem ${pxToEm(24, 16)}rem ${pxToEm(16, 16)}rem;

  span {
    display: block;
    font-size: ${pxToEm(20, 16)}rem;
    font-weight: bold;
    margin-bottom: ${pxToEm(12, 16)}rem;
  }

  .dialog-title {
    line-height: 1.2;
  }

  .dialog-subtitle {
    margin: 0;
  }

  .buttons-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: ${pxToEm(8, 16)}rem;

    button + button {
      margin-left: ${pxToEm(8, 16)}rem;
    }
  }
`;

interface ConfirmationPopupProps extends PageComponentProps {
  open: boolean;
  title: string;
  subtitle: string;
  okButtonName?: string;
  cancelButtonName?: string;
  onCancel?: () => void;
  onConfirmClick?: () => void;
}

const ConfirmationPopup: React.FunctionComponent<ConfirmationPopupProps> = ({
  idPrefix,
  open,
  title,
  subtitle,
  okButtonName,
  cancelButtonName,
  onCancel,
  onConfirmClick
}) => {
  if (open) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
  return (
    <>
      {open && (
        <ConfirmationPopupView>
          <PopupContent
            role="dialog"
            aria-describedby="dialog_desc"
            aria-labelledby="dialog_label"
            aria-modal="true"
          >
            <span id="dialog_label" className="cfl dialog-title">
              {title}
            </span>
            <p id="dialog_desc" className="dialog-subtitle cfl">
              {subtitle}
            </p>
            <div className="buttons-wrap">
              {cancelButtonName && onCancel && (
                <Button
                  data-testid={`${idPrefix}-cancel`}
                  onClick={onCancel}
                  fontWeightNormal
                  borderless
                >
                  {cancelButtonName}
                </Button>
              )}
              {okButtonName && onConfirmClick && (
                <Button
                  data-testid={`${idPrefix}-confirm`}
                  onClick={onConfirmClick}
                  borderless
                >
                  {okButtonName}
                </Button>
              )}
            </div>
          </PopupContent>
        </ConfirmationPopupView>
      )}
    </>
  );
};

export default ConfirmationPopup;
